import { MDBCheckbox, MDBTimepicker } from "mdb-react-ui-kit";
import React from "react";
import { useTranslation } from "react-i18next";

function LocWeeklySchedule({
  register,
  getValues,
  setValue,
  checkedSelected,
  twentyFourFlag,
  fromTime,
  toTime,
  fieldLabel,
  errors,
  clearErrors,
  watch,
  disabled
}) {

  const getError = (field) => {
    const day = fieldLabel.toLowerCase().substring(0, 3);
    return errors?.schedule?.weekly_schedule?.[day]?.[field]?.message;
  };
  const { t, i18n } = useTranslation();
//  alert(watch(toTime));
  return (
    <>
      <div className="pt-4 d-flex align-items-center justify-content-between">
        <div className="w_150px d-flex align-items-center">
          <label className="switch">
            <input
              className="form-control"
              type="checkbox"
              disabled={disabled}
              checked={watch(checkedSelected)}
              id={`${checkedSelected}`}
              onChange={(e) => {
                setValue(checkedSelected, e.target.checked, {
                  shouldDirty: true,
                });
                if (e.target.checked) {
                  setValue(twentyFourFlag, false , { shouldDirty: true });
                  setValue(fromTime, ((watch(fromTime) && watch(fromTime).trim() !== "") ? watch(fromTime) : "08:00 AM"), { shouldDirty: true });
                  setValue(toTime, ((watch(toTime) && watch(toTime).trim() !== "") ? watch(toTime) : "05 :00 PM"), { shouldDirty: true });
                }
              }}
            />
            <span className="slider round"></span>
          </label>
          {fieldLabel}
        </div>
        {watch(checkedSelected) && (
          <>
            <div className="w-50 d-flex col-7">
              <label className="px-2 pt-2">{t("from")}</label>
              <MDBTimepicker inline
                label={false}
                id={`${fromTime}`}
                disabled={disabled || watch(twentyFourFlag)}
                value={watch(fromTime) ?? "08:00 AM"}
                inputLabel=""
                onChange={(value) => {
                  // clearErrors(fromTime);
                  clearErrors && clearErrors(fromTime);
                  setValue(fromTime, value, { shouldDirty: true })
                }
                }
              />
               {getError('from_time') && (
                <p className="text-danger">{getError('from_time')}</p>
              )}

              <label className="px-1 pt-2">{t("to")}</label>
              <MDBTimepicker inline
                label={false}
                id={`${toTime}`}
                disabled={disabled || watch(twentyFourFlag)}
                value={(watch(toTime)) ?? "05:00 PM"}
                inputLabel=""
                onChange={(value) => {
                  // clearErrors(toTime);
                  clearErrors && clearErrors(toTime);
                  setValue(toTime, value, { shouldDirty: true })
                }
                }
              />
                 {getError('to_time') && (
                <p className="text-danger">{getError('to_time')}</p>
              )}
            </div>

            <div className="pt-1">
              <MDBCheckbox
                name="flexCheck"
                value=""
                id="flexCheckDefault"
                label="24 hours"
                disabled={disabled}
                checked={watch(twentyFourFlag)}
                onChange={(e) => {
                  setValue(twentyFourFlag, e.target.checked, {
                    shouldDirty: true,
                  })
                  if(!e.target.checked){
                   setValue(fromTime, "8:00 AM",{shouldDirty: true})
                  setValue(toTime,"5:00 PM",{shouldDirty:true})
                  }else{
                    setValue(fromTime, "12:00 AM",{shouldDirty: true})
                    setValue(toTime,"11:59 PM",{shouldDirty:true})
                  }
                 
                }
                  
                }
              />
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default LocWeeklySchedule;